// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"75770962","387":"795cbfeb","810":"36c7b783","866":"acb7285a"}[chunkId] + ".chunk.js";
};